@if(!menuloading()) {
@if(mymenu?.menu2?.asHtml) {
<div #htmlcontainer></div>
} @else {
<div class="stiky">
    @if(mymenu.isDefault2()) {
    <clever-header2></clever-header2>
    } @else {
    <ng-container *ngTemplateOutlet="default1"></ng-container>
    }
</div>
}
}

<ng-template #default1>
    <ng-container *ngIf="desktopTemplate else mobileMode">
        <header class="header">
            <ng-container *ngTemplateOutlet="navcontent"></ng-container>
        </header>
    </ng-container>

    <ng-container *ngIf="mymenu?.menu?.active">
        <div class="sidenav-overlay" [hidden]="!menuopen" (click)="closeMenu($event)">
            <div id="mySidenav" class="sidenav noselect customscroll" [class.leftmnu]="desktopTemplate"
                [class.rightmnu]="!desktopTemplate" [class.w100]="mobile">
                <div class="cc1">
                    <div class="menuItem">
                        <ng-container *ngIf="mymenu.menuHistory.length > 1">
                            <button class="cc2" (click)="gobackMenu($event)">
                                <mat-icon>keyboard_arrow_left</mat-icon>
                            </button>
                        </ng-container>
                        <div [class.pl5]="mymenu.menuHistory.length === 1">
                            <span multilang>{{mymenu.currentMenuName}}</span>
                        </div>
                        <button (click)="closeMenu($event)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                    <mat-divider></mat-divider>

                    <ng-container *ngIf="!desktopTemplate && mymenu?.menuHistory?.length <= 1">
                        @if(showTermin){
                        <div>
                            <div class="menuItem" (click)="gotoCalendar()">
                                <span multilang>Termin</span>
                            </div>
                            <mat-divider></mat-divider>
                        </div>
                        }
                        @if(showChat){
                        <div>
                            <div class="menuItem" (click)="openChat()">
                                <span multilang>Chat</span>
                            </div>
                            <mat-divider></mat-divider>
                        </div>
                        }
                        @if(showhReisekompass){
                        <div>
                            <div class="menuItem" (click)="gotoContent()">
                                <span multilang>Reisekompass</span>
                            </div>
                            <mat-divider></mat-divider>
                        </div>
                        }
                        @if(currentCustomer?.asPartner && showhLogin){
                        <div>
                            <div class="menuItem" (click)="gotoOfferpack()">
                                <span multilang [matBadge]="offerpackCount > 0 ? offerpackCount : ''"
                                    matBadgePosition="after" matBadgeOverlap="false"
                                    matBadgeColor="warn">Angebotsliste</span>
                            </div>
                            <mat-divider></mat-divider>
                        </div>
                        }
                        <ng-container *ngTemplateOutlet="menuGlbMobile"></ng-container>
                    </ng-container>
                    @if(mymenu.menuHistory?.length > 0){
                    @for(gm of mymenu.menuHistory[mymenu.menuHistory.length - 1].list; track gm.title) {
                    @if(gm.active){
                    <app-globalmenu-item1 [data]='gm' (openLink)="openLink($event)"
                        (opensubmenu)="opensubmenu($event)"></app-globalmenu-item1>
                    }
                    }
                    }
                </div>
            </div>
        </div>
    </ng-container>
</ng-template>


<ng-template #mobileMode>
    <div class="headermob">
        <ng-container *ngTemplateOutlet="mobilelogo"></ng-container>

        <div style="display: flex;align-items: center;">

            <!-- <a  multilang href="tel:{{partner?.tel}}" aria-label="phone" class="headerbtn cc10">
                <mat-icon >phone</mat-icon>
            </a> -->
            @if(partner && !partner?.hideSearch) {
            <button class="headerbtn" aria-label="search" (click)="showsearch = !showsearch;">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                    fill="currentColor">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                        d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
                </svg>
            </button>
            }
            @if(showhLogin) {
            <ng-container *ngIf="currentCustomer?.email else anmelden">
                <button [matMenuTriggerFor]="custmenu" aria-label="menu" class="headerbtn">
                    <mat-icon fontIcon="account_circle"></mat-icon>
                </button>
            </ng-container>
            <ng-template #anmelden>
                <button class="headerbtn" (click)="gotoPartner()" aria-label="login">
                    <mat-icon fontIcon="person"></mat-icon>
                </button>
            </ng-template>
            <mat-menu #custmenu="matMenu">
                <button mat-menu-item (click)="logout()">
                    <mat-icon fontIcon="exit_to_app"></mat-icon> Logout
                </button>
            </mat-menu>
            }

            <button [disabled]="favoritesCount === 0" aria-label="favorite" (click)="gotofavorites()" class="headerbtn">
                <mat-icon aria-hidden="false" [matBadge]="favoritesCount > 0 ? favoritesCount : ''"
                    matBadgePosition="before" matBadgeColor="warn" fontIcon="favorite"></mat-icon>
            </button>

            <button (click)="openMenu($event);" aria-label="menu" class="headerbtn cc9">
                <mat-icon fontIcon="menu"></mat-icon>
            </button>
        </div>
    </div>
    @if(showsearch && partner && !partner?.hideSearch) {
    <clever-headersearch></clever-headersearch>
    }
</ng-template>

<ng-template #menuGlb>
    <button class="tttflexy" aria-label="menu" (click)="openMenu($event)" matRipple>
        <mat-icon fontIcon="menu" class="mnubtn"></mat-icon>
    </button>
    <button (click)="gotoPath('pauschalreisen')" class="nav-item" [class.hdactive]="isactivemenu === 'pauschalreisen'"
        matRipple>
        Pauschalreisen
    </button>
    <button (click)="gotoPath('hotels')" class="nav-item" [class.hdactive]="isactivemenu === 'hotels'" matRipple>
        Hotel
    </button>
    <button (click)="gotoPath('flug')" class="nav-item" [class.hdactive]="isactivemenu === 'flug'" matRipple>
        Flug
    </button>
    <button (click)="gotoPath('pauschalreisen', 'fplush')" class="nav-item" [class.hdactive]="isactivemenu === 'fplush'"
        matRipple>
        Flug + Hotel
    </button>
    <button (click)="gotoPath('bahnreisen')" class="nav-item" [class.hdactive]="isactivemenu === 'bahnreisen'"
        matRipple>
        Bahn + Hotel
    </button>
    <ng-container *ngIf="cruiseActive">
        <button (click)="gotoPath('kreuzfahrten')" class="nav-item" [class.hdactive]="isactivemenu === 'kreuzfahrten'"
            matRipple>
            Kreuzfahrten
        </button>
    </ng-container>
    <button (click)="gotoPath('mietwagen')" class="nav-item" [class.hdactive]="isactivemenu === 'mietwagen'" matRipple>
        Mietwagen
    </button>
    <ng-container *ngIf="ferienhauserActive">
        <button (click)="gotoFerienhauser()" class="nav-item" [class.hdactive]="isactivemenu === 'ferienhauser'"
            matRipple>
            Ferienhäuser
        </button>
    </ng-container>
    <ng-container *ngIf="camperActive">
        <button (click)="gotoPath('camper')" class="nav-item" [class.hdactive]="isactivemenu === 'camper'" matRipple>
            Camper
        </button>
    </ng-container>
</ng-template>

<ng-template #menuGlbMobile>
    @if(showhDigbrater) {
    <div>
        <div class="menuItem" (click)="gotoAnfrage()">
            <span multilang>Digitaler Reiseberater</span>
        </div>
        <mat-divider></mat-divider>
    </div>
    }
    <div>
        <div class="menuItem" (click)="gotoPath('pauschalreisen')">
            <span multilang>Pauschalreisen</span>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div>
        <div class="menuItem" (click)="gotoPath('hotels')">
            <span multilang>Hotel</span>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div>
        <div class="menuItem" (click)="gotoPath('flug')">
            <span multilang>Flug</span>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div>
        <div class="menuItem" (click)="gotoPath('pauschalreisen', 'fplush')">
            <span multilang>Flug + Hotel</span>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div>
        <div class="menuItem" (click)="gotoPath('bahnreisen')">
            <span multilang>Bahn + Hotel</span>
        </div>
        <mat-divider></mat-divider>
    </div>
    <ng-container *ngIf="cruiseActive">
        <div>
            <div class="menuItem" (click)="gotoPath('kreuzfahrten')">
                <span multilang>Kreuzfahrten</span>
            </div>
            <mat-divider></mat-divider>
        </div>
    </ng-container>
    <div>
        <div class="menuItem" (click)="gotoPath('mietwagen')">
            <span multilang>Mietwagen</span>
        </div>
        <mat-divider></mat-divider>
    </div>
    <ng-container *ngIf="ferienhauserActive">
        <div>
            <div class="menuItem" (click)="gotoFerienhauser()">
                <span multilang>Ferienhäuser</span>
            </div>
            <mat-divider></mat-divider>
        </div>
    </ng-container>
    <ng-container *ngIf="camperActive">
        <div>
            <div class="menuItem" (click)="gotoPath('camper')">
                <span multilang>Camper</span>
            </div>
            <mat-divider></mat-divider>
        </div>
    </ng-container>
</ng-template>

<ng-template #mobilelogo>
    <div>
        <button class="logo-a-mobile" (click)="gotohome()">
            <ng-container *ngIf="logo?.length > 0">
                <img class="lazyload logo-img-mobile" src="{{logo}}" alt="{{partner?.firmenname}} logo">
            </ng-container>
            <ng-container *ngIf="!(partner?.noname)">
                <span multilang
                    *ngIf="partnername?.length > 0 && partner?.partnerid !== 'main' && partner?.partnerid !== 'reisen'"
                    class="pnamew pp-mobile">{{partner?.partnerid === 'main' ? '' : partnername}}</span>
            </ng-container>
        </button>
    </div>
</ng-template>

<ng-template #navcontent>
    <div class="subheaderwrapper">
        <div class="logowrapper">
            <div class="ml5">
                <button (click)="gotohome()" class="logo-a">
                    <ng-container *ngIf="logo?.length > 0">
                        <img class="lazyload a-img" src="{{logo}}" height="36" width="auto"
                            alt="{{partner?.firmenname}} logo">
                    </ng-container>
                    <ng-container *ngIf="!(partner?.noname)">
                        <span multilang class="pnamew">{{partner?.partnerid === 'main' ? '' :
                            partnername}}</span>
                    </ng-container>
                </button>
            </div>
        </div>
        @if(partner && !partner?.hideSearch) {
        <clever-headersearch></clever-headersearch>
        }
        <div class="headerwrapper mr5">
            <ng-container *ngTemplateOutlet="subnavcontent"></ng-container>
        </div>
    </div>
    <div class="tmp_right-wrapper">
        <div class="tmp_mnwrp">
            <div class="dflx ml5">
                <ng-container *ngTemplateOutlet="menuGlb"></ng-container>
            </div>
            <div class="dflx mr5">
                @if(showhLogin && currentCustomer?.asPartner){
                <app-chatampel></app-chatampel>
                }
                @if(showhDigbrater) {
                <button (click)="gotoAnfrage()" class="headerbtn" aria-label="Digitaler Reiseberater"
                    matTooltip="Digitaler Reiseberater" matRipple>
                    <mat-icon fontIcon="smart_toy"></mat-icon>
                </button>
                }
                @if(showhReisekompass) {
                <button (click)="gotoContent()" class="headerbtn" aria-label="Reisekompass" matTooltip="Reisekompass"
                    matRipple>
                    <mat-icon fontIcon="explore"></mat-icon>
                </button>
                }
                <button (click)="gotofavorites()" [matBadge]="favoritesCount > 0 ? favoritesCount : ''"
                    matBadgeOverlap="false" matTooltip="Favoriten" aria-label="favorite" matBadgeSize="small"
                    matBadgePosition="above after" matBadgeColor="warn" class="headerbtn" matRipple>
                    <mat-icon fontIcon="favorite"></mat-icon>
                </button>
                @if(showhLogin && currentCustomer?.asPartner){
                <button (click)="gotoOfferpack()" [matBadge]="offerpackCount > 0 ? offerpackCount : ''"
                    matBadgeOverlap="false" matTooltip="Angebotsliste" matBadgeSize="small"
                    matBadgePosition="above after" matBadgeColor="warn" class="headerbtn" matRipple>
                    <mat-icon fontIcon="local_offer"></mat-icon>
                </button>
                }
            </div>
        </div>
    </div>
</ng-template>

<ng-template #subnavcontent>
    <div class="submenuwrapper">
        @if(showTel) {
        <a multilang class="afon" href="tel:{{partner?.tel}}" (mouseover)="fixsetoultip=true"
            (mouseleave)="fixsetoultip=false" #trigertooltip="cdkOverlayOrigin" cdkOverlayOrigin>
            <span multilang>{{partner?.tel}}</span>
        </a>
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigertooltip"
            [cdkConnectedOverlayOpen]="fixsetoultip">
            <div class="cc17 mat-elevation-z1">
                <div class="cc19">
                    <b>{{partner?.tel}}</b><br>
                    @if(partner?.opening_period?.length > 0) {
                    <span multilang class="mt1 cc20">{{partner.opening_period}}</span>
                    } @else {
                    <span multilang>Beratung & Buchung täglich von</span><br>
                    <span multilang class="mt1 cc20">{{'08 - 23 Uhr'}}</span>
                    }
                </div>
            </div>
        </ng-template>
        }
        @if(showTermin) {
        <button class="headerbtn" matTooltip="Termin" aria-label="Termin" (click)="gotoCalendar()">
            <!-- <mat-icon fontIcon="event"></mat-icon> -->
            <mat-icon fontIcon="perm_contact_calendar"></mat-icon>
        </button>
        }
        @if(showChat) {
        <button class="headerbtn" matTooltip="Chat" aria-label="Chat" (click)="openChat()">
            <!-- <span  multilang >Chat</span> -->
            <mat-icon fontIcon="question_answer"></mat-icon>
        </button>
        }
        @if(showhLogin) {
        @if(currentCustomer?.email?.length > 0) {
        <button [matMenuTriggerFor]="custmenu" [matTooltip]="currentCustomer?.firstname ? currentCustomer.firstname + ' ' + currentCustomer.lastname :
                'Mein Konto'" class="headerbtn " matRipple>
            <!-- <span  multilang >{{currentCustomer?.firstname ? currentCustomer.firstname + ' ' + currentCustomer.lastname :
                        'Mein Konto'}}</span> -->
            <mat-icon fontIcon="account_circle"></mat-icon>
        </button>
        <mat-menu #custmenu="matMenu">
            <button mat-menu-item (click)="logout()" aria-label="Logout" matRipple>
                <mat-icon>exit_to_app</mat-icon> Logout
            </button>
        </mat-menu>
        } @else {
        <ng-container *ngTemplateOutlet="anmelden"></ng-container>
        }

        <ng-template #anmelden>
            <button class="headerbtn " matTooltip="Anmelden" aria-label="Anmelden" (click)="gotoPartner()">
                <mat-icon fontIcon="person"></mat-icon>
            </button>
        </ng-template>
        }
    </div>
</ng-template>